export default __webpack_public_path__ + "481a9aabae45e488cceb58f6f742c846.png";